import { useMemo } from 'react';
import qs from 'query-string';
import { getRootUrl } from '@utils/urlHelpers.util';

export function useQueryParams(options?: qs.ParseOptions) {
  const search = new URL(typeof window !== 'undefined' ? window.location.href : getRootUrl('/')).search;
  return useMemo(() => qs.parse(search, { ...options, parseBooleans: true }), [options, search]);
}
